/** Fixed layout inside Shadow DOM; only validated theme values are inherited. */
export const consentStyles = `
  :host { all: initial; }
  *, *::before, *::after { box-sizing: border-box; }
  [hidden] { display: none !important; }
  .prospix-consent-shell {
    position: fixed; z-index: 2147483646;
    left: max(12px, env(safe-area-inset-left));
    bottom: max(12px, env(safe-area-inset-bottom));
    width: min(360px, calc(100vw - max(12px, env(safe-area-inset-left)) - max(12px, env(safe-area-inset-right))));
    color: var(--prospix-consent-text);
    font-family: var(--prospix-consent-font);
    font-size: 13px; line-height: 1.45; letter-spacing: normal;
    text-align: start; overflow-wrap: anywhere;
  }
  .prospix-consent-shell--preferences { width: auto; }
  .prospix-consent-panel {
    position: relative; padding: 14px;
    max-height: calc(100vh - 24px); max-height: calc(100dvh - 24px - env(safe-area-inset-bottom));
    overflow-y: auto; overscroll-behavior: contain;
    border: 1px solid var(--prospix-consent-text); border-radius: 10px;
    background: var(--prospix-consent-background);
    box-shadow: 0 4px 20px rgb(0 0 0 / 16%);
  }
  .prospix-consent-title { margin: 0; font-size: 14px; font-weight: 700; line-height: 1.4; }
  .prospix-consent-copy { margin: 6px 0 0; }
  .prospix-consent-link { display: inline-block; padding-block: 4px; margin-top: 2px; color: var(--prospix-consent-accent); text-decoration: underline; text-underline-offset: 2px; }
  .prospix-consent-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; margin-top: 10px; }
  .prospix-consent-actions:has(> :nth-child(3)) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  button { min-width: 0; min-height: 44px; border: 1px solid var(--prospix-consent-text); border-radius: 6px; padding: 7px 6px; font: inherit; font-weight: 600; cursor: pointer; color: inherit; background: var(--prospix-consent-background); overflow-wrap: anywhere; }
  button:hover { text-decoration: underline; text-underline-offset: 3px; }
  button:focus-visible, a:focus-visible, input:focus-visible, .prospix-consent-panel:focus-visible { outline: 2px solid var(--prospix-consent-accent); outline-offset: 2px; }
  .prospix-consent-options { margin-top: 8px; }
  .prospix-consent-option { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 44px; padding: 6px 0; cursor: pointer; }
  .prospix-consent-option input { flex: 0 0 auto; width: 18px; height: 18px; margin: 0 3px; accent-color: var(--prospix-consent-accent); }
  input:disabled { cursor: default; }
  :host([data-prospix-consent-enforcement="preview"]) .prospix-consent-title { padding-inline-end: 38px; min-height: 30px; }
  .prospix-consent-dismiss { position: absolute; inset-block-start: 3px; inset-inline-end: 3px; width: 44px; height: 44px; padding: 0; border: 0; border-radius: 6px; font-size: 22px; line-height: 1; }
  .prospix-consent-preferences { display: grid; place-items: center; width: 44px; height: 44px; padding: 10px; border-radius: 50%; box-shadow: 0 3px 12px rgb(0 0 0 / 16%); }
  .prospix-consent-preferences svg { display: block; width: 22px; height: 22px; }
  @media (max-width: 340px) { .prospix-consent-panel { padding: 12px; } .prospix-consent-actions:has(> :nth-child(3)) { grid-template-columns: 1fr; } }
  @media (forced-colors: active) { button, .prospix-consent-panel { border-color: ButtonText; } }
`;
